const initialState = {
	data: [],
	total: 0,
	params: {},
}

const p2phistory = (state = initialState, action) => {
	switch (action.type) {
		case 'P2PHISTORY_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		default:
			return state
	}
}

export default p2phistory
